class settings {
    static recentlyViewedCount = 6;
    static irrMaxLedgerLength = 45;
    static sorMaxLedgerLength = 35;
    static inflationMaxLedgerLength = 45;
    static superRebalancerMaxLedgerLength = 40;
}

export default settings;